import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "service", spoke: "service", title: "Service", icon: HandymanOutlinedIcon, order: 59, entries: [
  { label: "Overview", to: "/app/service", permission: "service.work.view" },
  { label: "Dispatch board", to: "/app/service/dispatch", permission: "service.work.view" },
  { label: "My jobs (mobile)", to: "/app/service/mobile", permission: "service.work.execute" },
  { label: "Requests", to: "/app/service/requests", permission: "service.request.view" },
  { label: "Work orders", to: "/app/service/work", permission: "service.work.view" },
  { label: "Installed equipment", to: "/app/service/equipment", permission: "service.equipment.view" },
  { label: "Contracts", to: "/app/masterdata/service-contracts", permission: "service.equipment.view" },
  { label: "Warranty terms", to: "/app/masterdata/warranty-terms", permission: "service.equipment.view" },
] });
